import { render, staticRenderFns } from "./ButtonSwitch.vue?vue&type=template&id=3987985a&scoped=true&"
import script from "./ButtonSwitch.vue?vue&type=script&lang=js&"
export * from "./ButtonSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSwitch.vue?vue&type=style&index=0&id=3987985a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987985a",
  null
  
)

export default component.exports